module.exports = __webpack_public_path__ + "0134897bcfe2c48ac56c1df2e59404d8.png";